import React from 'react';
import { FiSearch } from 'react-icons/fi';

const SearchInput = React.memo(({ searchTerm, handleSearchChange, t }) => (
    <div className="th-search-wrap">
        <FiSearch className="th-search-icon" />
        <input
            type="text"
            className="form-control search-input"
            placeholder={t('searchHere')}
            value={searchTerm}
            onChange={handleSearchChange}
            autoComplete="off"
            spellCheck="false"
        />
    </div>
));

export default SearchInput;
